import { useCallback } from "react"
import { useContext, useEffect, useState } from "react"
import { MdLibraryAdd, MdSearch } from "react-icons/md"
import { useNavigate } from "react-router-dom"
import UserContext from "../../Context/UserContext"
import { createGroupDoc, getGroupsDocWhereExhibitor } from "../../Requests/firebaseFirestore"
import Modal from "../Modal"
import Spinner from "../Spinner"

export default function GroupsAsExhibitor() {
  const [groups, setGroups] = useState([])
  const [groupList, setGroupList] = useState([])
  const navigate = useNavigate()
  const {user, seeAs} = useContext(UserContext)
  const [newGroup, setNewGroup] = useState({})
  const [events, setEvents] = useState([])
  const [newGroupModal, setNewGroupModal] = useState(false)
  const [exhibitor, setExhibitor] = useState({})
  const [creating, setCreating] = useState(false)
  const [search, setSearch] = useState({name:'', event:''})
  const [loading, setLoading] = useState(true)

  const handleNewGroupModal = () =>{
    setNewGroup({})
    setNewGroupModal(!newGroupModal)
  }


  const reloadGroupList = useCallback(
    async () => {
      setLoading(true)
      if(seeAs===''){
        const res = await getGroupsDocWhereExhibitor(user.uid)
        setEvents([...user.events])
        setExhibitor({
          fullName:user.fullName,
          id:user.uid
        })
        setGroups(res)
        setGroupList([...res])
      }else{
        const res = await getGroupsDocWhereExhibitor(seeAs.id)
        setEvents([...seeAs.events])
        setExhibitor({
          fullName:seeAs.fullName,
          id:seeAs.id
        })
        setGroups(res)
        setGroupList([...res])
      }
      setLoading(false)
    } ,[seeAs, user]
  ) 

  const handleSubmitSearch = (e) =>{
    e.preventDefault()
    let filteredList = []
    groups.forEach((group)=>{
      if(group.name.toLowerCase().includes(search.name.toLowerCase())&&(group.event.id===search.event||search.event==='')){
        filteredList = [...filteredList, group]
      }
    })
    setGroupList([...filteredList])
  }


  useEffect(()=>{
    if(user.uid){
      reloadGroupList()
    }
  }, [user, seeAs, reloadGroupList])

  const handleInputChange = (e) => {
    const {name, value} = e.target
    setNewGroup({...newGroup, [name]:value})
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setCreating(true)
    await createGroupDoc({
      name:newGroup.name,
      event:JSON.parse(newGroup.event),
      exhibitor:{...exhibitor},
      guests:[]
    })
    handleNewGroupModal()
    setCreating(false)
    await reloadGroupList()
  }

  return <>
  {loading?<div className="flex justify-center mt-5">
    <Spinner/>
  </div>:<>
   <form onSubmit={handleSubmitSearch} className="flex gap-2 my-4 justify-center flex-col sm:flex-row">

    <input className="w-full max-w-[300px] sm:w-fit mx-auto sm:mx-0" type="text" placeholder="buscar por nombre" value={search.name || ''} onChange={(e)=>{setSearch({...search, name:e.target.value})}}/>
    <select className="w-full sm:w-fit max-w-[300px] mx-auto sm:mx-0" value={search.event||''} onChange={(e)=>{setSearch({...search, event:e.target.value})}}>
      <option value="">Todos los eventos</option>
      {events.map((event, index)=>{return(
        <option value={event.id} key={index}>{event.name}</option>
        )})}
    </select>
    <button className="action-btn mx-auto sm:mx-0"><MdSearch size={25}/></button>
        </form>
  <h1 className="text-stone-600 font-semibold text-xl py-2">Mis grupos</h1>
    <div className=" grid grid-cols-2 sm:grid-cols-4 gap-4">
    <button onClick={handleNewGroupModal} className="group-btn">
      <h1 className="flex items-center gap-2"><MdLibraryAdd size={25}/> Nuevo grupo</h1>
    </button>
    <button onClick={()=>{navigate('/exhibitor/group/all')}} className="group-btn">
      <h1>Todos los contactos</h1>
    </button>
    {groupList.map((group, index)=>{
      return(
        <button onClick={()=>{navigate(`/exhibitor/group/${group.id}`)}} key={index} className="group-btn">
        <h1 className="flex items-center gap-2">{group.name}</h1>
      </button>
      )
    })}
    <Modal isActive={newGroupModal} handle={handleNewGroupModal} title='Nuevo grupo'>
    <form className='flex flex-col gap-4' onSubmit={handleSubmit}>
        <div className="input-holder w-[75%]">
          <input type='text' name="name" id="new-group-name" onChange={handleInputChange} value={newGroup.name || ''} required></input>
          <label htmlFor="new-group-name">Nombre</label>
        </div>
        <div className="input-holder w-[75%]">
          <select id="new-group-event" onChange={handleInputChange} name='event' value={newGroup.event|| ''} required >
            <option value="" hidden disabled></option>
            {events.map((event,index)=>{
              return <option value={JSON.stringify(event)} key={index}>{event.name}</option>
            })}
          </select>
          <label htmlFor="new-group-event">Evento</label>
        </div>
      <button className="send-btn" disabled={creating}>{creating?'Creando...':'Crear'}</button>
      </form>
    </Modal>
  </div>
            </>}
</>
}